/**
 * Environment Debug Utility
 * Helps debug environment variable issues in different environments
 */

export function debugEnvironmentVariables() {
  console.log("🔍 Environment Variables Debug Report");
  console.log("=====================================");

  // Check if we're in a browser environment
  if (typeof window !== "undefined") {
    console.log("🌐 Browser Environment Detected");
    console.log("📍 Current URL:", window.location.href);
    console.log("🏠 Hostname:", window.location.hostname);
    console.log("🔗 Protocol:", window.location.protocol);
  }

  // Check Vite environment variables
  console.log("\n📋 Vite Environment Variables:");
  console.log(
    "VITE_OPENAI_API_KEY:",
    import.meta.env.VITE_OPENAI_API_KEY
      ? `${import.meta.env.VITE_OPENAI_API_KEY.substring(0, 20)}...`
      : "NOT SET",
  );
  console.log(
    "VITE_SUPABASE_URL:",
    import.meta.env.VITE_SUPABASE_URL
      ? `${import.meta.env.VITE_SUPABASE_URL.substring(0, 20)}...`
      : "NOT SET",
  );
  console.log(
    "VITE_SUPABASE_ANON_KEY:",
    import.meta.env.VITE_SUPABASE_ANON_KEY
      ? `${import.meta.env.VITE_SUPABASE_ANON_KEY.substring(0, 20)}...`
      : "NOT SET",
  );
  console.log(
    "VITE_GA_MEASUREMENT_ID:",
    import.meta.env.VITE_GA_MEASUREMENT_ID || "NOT SET",
  );

  // Check mode
  console.log("\n🎯 Build Mode:", import.meta.env.MODE);
  console.log("🏗️  Dev Mode:", import.meta.env.DEV);
  console.log("🚀 Prod Mode:", import.meta.env.PROD);

  // Check for common issues
  console.log("\n🔍 Common Issues Check:");

  const openaiKey = import.meta.env.VITE_OPENAI_API_KEY;
  if (!openaiKey) {
    console.log("❌ VITE_OPENAI_API_KEY is not set");
  } else if (openaiKey === "dummy-key") {
    console.log("❌ VITE_OPENAI_API_KEY is set to dummy-key");
  } else if (openaiKey.length < 20) {
    console.log("❌ VITE_OPENAI_API_KEY appears to be too short");
  } else {
    console.log("✅ VITE_OPENAI_API_KEY appears to be properly set");
  }

  // Check if we're in staging
  const isStaging =
    window.location.hostname.includes("staging") ||
    window.location.hostname.includes("netlify.app") ||
    window.location.hostname.includes("vercel.app");

  console.log("\n🌍 Environment Detection:");
  console.log("Is Staging:", isStaging);
  console.log("Is Local:", window.location.hostname.includes("localhost"));
  console.log(
    "Is Production:",
    !isStaging && !window.location.hostname.includes("localhost"),
  );

  // Provide recommendations
  console.log("\n💡 Recommendations:");

  if (!openaiKey || openaiKey === "dummy-key") {
    console.log(
      "1. Add VITE_OPENAI_API_KEY to your hosting platform environment variables",
    );
    console.log(
      "2. Redeploy your application after adding the environment variable",
    );
    console.log("3. Clear browser cache and try again");
  } else {
    console.log("1. Environment variable appears to be set correctly");
    console.log("2. If still having issues, try redeploying the application");
    console.log("3. Check if the API key is valid and has sufficient credits");
  }

  console.log("\n=====================================");
}

export function testOpenAIKey() {
  const openaiKey = import.meta.env.VITE_OPENAI_API_KEY;

  if (!openaiKey || openaiKey === "dummy-key") {
    console.log("❌ OpenAI API key not available for testing");
    return false;
  }

  console.log("🧪 Testing OpenAI API key...");
  console.log(
    "Key format:",
    openaiKey.startsWith("sk-") ? "Valid format" : "Invalid format",
  );
  console.log("Key length:", openaiKey.length, "characters");

  return true;
}

// Auto-run debug when imported
if (typeof window !== "undefined") {
  // Only run in browser environment
  debugEnvironmentVariables();
}
